/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cut': {
    width: 16,
    height: 16,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M10.2 59.9c-.2 0-.5 0-.6-.1-1.4-.3-2.5-1.4-3-3.1-1.2-4-2-9.8 1.3-14 2.9-3.7 8.2-5.5 15.8-5.2l-.1 2.3L53.8.1l2.8 2.2-42 54.9c-1.7 2.2-3.3 2.7-4.4 2.7zM22 41c-5.6 0-9.5 1.3-11.4 3.8-2.4 3.1-1.7 7.6-.7 10.8.1.4.3.6.3.6.1 0 .7-.2 1.6-1.4L22.5 41H22z" _fill="#7d7d7d"/><path pid="1" d="M50.5 59.9c-1 0-2.6-.5-4.2-2.7C37.1 43.7 4.3 2.7 3.9 2.3L6.7 0c.3.3 17.4 21.8 30.4 38.8v-1.3c7.5.1 12.8 2 15.6 5.8 3.1 4.2 2.5 9.6 1.4 13.4-.5 1.8-1.6 2.9-3.1 3.2h-.5zM38.9 41.1c4.3 5.7 8.1 10.7 10.4 14 .6.8 1 1.1 1.2 1.2 0-.1.1-.2.2-.6.9-3 1.4-7.3-.8-10.3-2-2.6-5.7-4-11-4.3z" _fill="#7d7d7d"/>'
  }
})
